import axios from 'axios'
import { put, call, take, fork, select } from 'redux-saga/effects'
import { push } from 'react-router-redux'

import {
  FETCH_PROJECT,
  FETCH_PROJECT_SUCCESS,
  FETCH_PROJECT_FAILURE,
  FETCH_RANKING,
  FETCH_RANKING_SUCCESS,
  FETCH_RANKING_FAILURE,
  FETCH_ANSWER_COUNT,
  FETCH_ANSWER_COUNT_SUCCESS,
  FETCH_ANSWER_COUNT_FAILURE,
  UPDATE_REALTIME_ANSWER_CHOICE,
  UPDATE_REALTIME_ANSWER_CHOICE_FAILURE,
  UPDATE_REALTIME_ANSWER_CHOICE_SUCCESS
} from '../actions/presentationActions'

const presentationStore = state => state.presentation

export function* runFetchProjectHandler() {
  while (true) {
    const { payload } = yield take([`${FETCH_PROJECT}`])
    yield fork(fetchProjectHandler, payload)
  }
}
function* fetchProjectHandler(env) {
  const { data, error } = yield call(fetchProject, env)
  // TODO: jsonで帰ってくるerrorにも対応
  if (error != null) {
    if (error.response && error.response.status === 401) {
      const redirect = encodeURIComponent(`${location.pathname}?env=${env}`)
      yield put(push(`/login?redirect=${redirect}`))
    }

    yield put(FETCH_PROJECT_FAILURE())
    return
  }
  yield put(FETCH_PROJECT_SUCCESS(data))
}
const fetchProject = env => {
  return axios
    .get(`/api/v1/organizers/projects?env=${env}`)
    .then(response => {
      return { data: response.data }
    })
    .catch(error => {
      return { error: error }
    })
}

export function* runFetchRankingHandler() {
  while (true) {
    const { payload } = yield take([`${FETCH_RANKING}`])
    yield fork(fetchRankingHandler, payload)
  }
}
function* fetchRankingHandler(payload) {
  const { data, error } = yield call(fetchRanking, payload)
  if (error != null) {
    alert('通信エラーが発生しました。ネットワークを確認して、ページを再読み込みしてください。')
    yield put(FETCH_RANKING_FAILURE())
    return
  }
  yield put(FETCH_RANKING_SUCCESS(data))
}
const fetchRanking = payload => {
  return axios
    .get(`/api/v1/organizers/projects/${payload.projectId}/ranking`)
    .then(response => {
      return { data: response.data }
    })
    .catch(error => {
      return { error: error }
    })
}

export function* runFetchAnswerCountHandler() {
  while (true) {
    const { payload } = yield take([`${FETCH_ANSWER_COUNT}`])
    yield fork(fetchAnswerCountHandler, payload)
  }
}
function* fetchAnswerCountHandler(payload) {
  const { data, error } = yield call(fetchAnswerCount, payload)
  if (error != null) {
    yield put(FETCH_ANSWER_COUNT_FAILURE())
    return
  }
  yield put(FETCH_ANSWER_COUNT_SUCCESS(data))
}
const fetchAnswerCount = payload => {
  return axios
    .get(
      `/api/v1/organizers/projects/${payload.projectId}/questions/${payload.questionId}/answer_count?env=${payload.env}`
    )
    .then(response => {
      return { data: response.data }
    })
    .catch(error => {
      return { error: error }
    })
}

/////////////////////////
/// 実演クイズの正解決定 ///
/////////////////////////

export function* runUpdateAnswerChoiceHandler() {
  while (true) {
    yield take([`${UPDATE_REALTIME_ANSWER_CHOICE}`])
    const presentation = yield select(presentationStore)
    yield fork(updateAnswerChoiceHandler, presentation)
  }
}

function* updateAnswerChoiceHandler(presentation) {
  const { error } = yield call(updateAnswerChoice, presentation)
  if (error != null) {
    yield put(UPDATE_REALTIME_ANSWER_CHOICE_FAILURE(error))
    return
  }
  yield put(UPDATE_REALTIME_ANSWER_CHOICE_SUCCESS())
}

const updateAnswerChoice = async presentation => {
  const question = presentation.project.questions[presentation.index]
  return await axios
    .patch(`/api/v1/organizers/projects/${presentation.project.id}/questions/${question.id}/answer_choice`, {
      answer_choice_id: question.answer_choice_id
    })
    .catch(error => ({ error: error.response.data }))
}
